import { isFeatureEnabled } from "@/domain/erpFeatures";
import { PERMISSION_FEATURE_MAP } from "@/domain/permissionCatalog";
import { platformRoleHasPermission } from "@/domain/platformPermissions";
import { customerRoleHasPermission } from "@/domain/customerPermissions";

function hasFeature(modules, feature) {
  return isFeatureEnabled(modules, feature);
}

function hasCustomerPermission(user, permissionId, { modules, role }) {
  const feature = PERMISSION_FEATURE_MAP[permissionId];
  if (feature && !hasFeature(modules, feature)) return false;
  const grants = user.permissions ?? [];
  if (grants.length > 0) {
    return grants.includes(permissionId);
  }
  if (role) {
    return customerRoleHasPermission(role, permissionId);
  }
  return false;
}

function hasPlatformPermission(operator, permissionId) {
  if (!operator) return false;
  return platformRoleHasPermission(operator.roleId, permissionId);
}

function canAccessCustomerNavItem(item, { role, modules, permissions }) {
  if (item.feature && !hasFeature(modules, item.feature)) return false;
  if (item.permission && !permissions.includes(item.permission)) return false;
  if (item.module && !modules[item.module] && item.module !== "admin") {
    const phase = item.module;
    if (!modules[phase]) return false;
  }
  return true;
}

export {
  canAccessCustomerNavItem,
  hasCustomerPermission,
  hasFeature,
  hasPlatformPermission,
};
